import { toBoolean } from '@waitroom/utils';
import { envs } from '../core/services/envs';

export const APPLE_CLIENT_ID = envs.VITE_APPLE_CLIENT_ID as string | undefined;

export const GOOGLE_CLIENT_ID = envs.VITE_GOOGLE_CLIENT_ID as string | undefined;
export const GOOGLE_RECAPTCHA_KEY = envs.VITE_GOOGLE_RECAPTCHA_KEY as string | undefined;
export const GOOGLE_RECAPTCHA_ENABLED = toBoolean(envs.VITE_USE_GOOGLE_RECAPTCHA);
